<lfx-dropdown-filter-panel [activeFilterCount]="activeFilterCount()" (clearAll)="clearFilters()">
  <!-- Date From -->
  <div class="filter-group">
    <label class="filter-label">Date From</label>
    <p-datepicker
      appendTo="body"
      placeholder="From"
      dateFormat="mm/dd/yy"
      [ngModel]="dateFrom()"
      (ngModelChange)="dateFrom.set($event)"
      [showIcon]="true"
      styleClass="w-full" />
  </div>

  <!-- Date To -->
  <div class="filter-group">
    <label class="filter-label">Date To</label>
    <p-datepicker
      appendTo="body"
      placeholder="To"
      dateFormat="mm/dd/yy"
      [ngModel]="dateTo()"
      (ngModelChange)="dateTo.set($event)"
      [showIcon]="true"
      styleClass="w-full" />
  </div>

  <!-- Field -->
  <div class="filter-group">
    <label class="filter-label">Field</label>
    <p-multiselect
      appendTo="body"
      [ngModel]="selectedAttributes()"
      (ngModelChange)="selectedAttributes.set($event)"
      [options]="attributeOptions()"
      placeholder="Select fields"
      optionLabel="displayName"
      styleClass="w-full"
      [panelStyle]="{ minWidth: '250px' }">
      <ng-template let-option pTemplate="item">
        <div class="text-sm">{{ option.displayName }}</div>
      </ng-template>
    </p-multiselect>
  </div>

  <!-- Resource -->
  @if (resourceOptions().length > 1) {
    <div class="filter-group">
      <label class="filter-label">Resource</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedResources()"
        (ngModelChange)="selectedResources.set($event)"
        [options]="resourceOptions()"
        placeholder="Select resources"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '250px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm">{{ option }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- User -->
  <div class="filter-group">
    <label class="filter-label">User</label>
    <p-multiselect
      appendTo="body"
      [ngModel]="selectedUsers()"
      (ngModelChange)="selectedUsers.set($event)"
      [options]="userOptions()"
      placeholder="Select users"
      optionLabel="displayName"
      styleClass="w-full"
      [panelStyle]="{ minWidth: '250px' }">
      <ng-template let-option pTemplate="item">
        <div class="flex gap-2 items-center">
          @if (option.profile_picture && option.profile_picture !== '') {
            <p-avatar [image]="option.profile_picture" (onImageError)="onImageError($event)" shape="circle" styleClass="avatar-image-fit !w-8 !h-8" />
          } @else {
            <p-avatar [label]="option.displayName || 'S' | initial" shape="circle" styleClass="!w-8 !h-8" />
          }
          <div class="text-sm truncate">{{ option.displayName }}</div>
        </div>
      </ng-template>
    </p-multiselect>
  </div>

  <!-- Action -->
  <div class="filter-group">
    <label class="filter-label">Action</label>
    <p-multiselect
      appendTo="body"
      [ngModel]="selectedActions()"
      (ngModelChange)="selectedActions.set($event)"
      [options]="actionOptions()"
      placeholder="Select actions"
      styleClass="w-full"
      [panelStyle]="{ minWidth: '200px' }">
      <ng-template let-option pTemplate="item">
        <div class="text-sm">{{ option }}</div>
      </ng-template>
    </p-multiselect>
  </div>

  <!-- Registrant -->
  @if (registrantOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Registrant</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedRegistrants()"
        (ngModelChange)="selectedRegistrants.set($event)"
        [options]="registrantOptions()"
        placeholder="Select registrants"
        optionLabel="displayName"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '250px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm truncate">{{ option.displayName }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }

  <!-- Attendee -->
  @if (attendeeOptions().length > 0) {
    <div class="filter-group">
      <label class="filter-label">Attendee</label>
      <p-multiselect
        appendTo="body"
        [ngModel]="selectedAttendees()"
        (ngModelChange)="selectedAttendees.set($event)"
        [options]="attendeeOptions()"
        placeholder="Select attendees"
        optionLabel="displayName"
        styleClass="w-full"
        [panelStyle]="{ minWidth: '250px' }">
        <ng-template let-option pTemplate="item">
          <div class="text-sm truncate">{{ option.displayName }}</div>
        </ng-template>
      </p-multiselect>
    </div>
  }
</lfx-dropdown-filter-panel>
